import get from "lodash/get"

// Позволяет забрать ресурс
export const selectResource = state => {
  return get(state, `api.resources.one`)
}

export const selectApiEntity = (state, name) => {
  return get(state, `api.${name}.one`)
}

export const selectApiEntityList = (state, name) => {
  return get(state, `api.${name}.list`)
}
